const CustomAlert = ({ alert }) => {
  return (
    <div className="bg-error-300 rounded-md p-4 flex flex-row gap-2 items-center">
      {/* Dynamically apply bg color */}
      <div
        className={`w-[2px] rounded-lg min-h-12 max-h-max flex items-center bg-${alert?.bg}`}
      ></div>
      <div className={`flex flex-col text-${alert?.bg}`}>
        <span className="font-bold">{alert?.label}</span>
        <span className="text-theme">{alert?.detail}</span>
      </div>
    </div>
  );
};

export default CustomAlert;
